<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <!--<h4 class="title"></h4>
                        <p class="category"></p>-->
                    </div>

                    <ng-container *ngIf="!showPage">
                        <div class="loading text-center">
                            <img src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                            <p>Loading Asessment, please wait...</p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showPage">
                        <div class="container-fluid">
                            <ng-container *ngIf="questionsContent">
                                <div class="questionsHeader">
                                    <div class="text-right">
                                        <i *ngIf="from_admin" [routerLink]="['/app/neweli']" class="small material-icons">undo</i>
                                        <i *ngIf="from_client" [routerLink]="['/app/pending']" class="small material-icons">home</i>
                                        <i class="small material-icons">info_outline</i>
                                        <!--<i (click)="nextQuestion()" class="rotate180 large material-icons">keyboard_backspace</i>-->
                                        <i *ngIf="showNextIcon" (click)="showNextQuestion()" class="rotate180 large material-icons">keyboard_backspace</i>
                                    </div>
                                    <h3>Assessment</h3>
                                    <h4>Question <span id="questionIndex">{{globalCurrentQuestion}}</span> of <span id="questionsTotal">{{ questionsTotal }}</span></h4>
                                </div>

                                <ng-container *ngIf="!showIcons && singleChoice">
                                    <div *ngIf="questionId < sectionQuestions.length">
                                        <p>
                                            {{sectionQuestions[currentQuestion].Text}}
                                        </p>
                                    </div>

                                    <!--Regular Questions-->
                                    <div class="buttons">
                                        <div *ngFor="let sectionChoice of sectionChoices; let i = index" class="btn-group" data-toggle="buttons">
                                            <label (click)="setOneActive($event)" id="{{sectionChoice.Id}}" class="btn btn-info form-check-label">
                                                <input name="answers" value="{{sectionChoice.Text | replaceSpaces}}" class="form-check-input" type="radio" autocomplete="off"> {{sectionChoice.Text}}
                                            </label>
                                        </div>
                                    </div>
                                </ng-container>
                                <!--Regular Questions-->


                                <!--Satisfaction questions-->
                                <ng-container *ngIf="showIcons && singleChoice">
                                    <div>
                                        <div *ngFor="let question of sectionQuestions; let i = index">
                                            <p>{{globalCurrentQuestion+(i)}}. {{question.Text}}</p>
                                            <input #face class="form-check-input" type="radio" name="face{{globalCurrentQuestion+(i)}}" value=""  style="opacity:0;"/>
                                            <div class="faces">
                                                <div *ngFor="let choice of sectionChoices | slice:0:3">
                                                    <i (click)="selectFace($event, globalCurrentQuestion+(i))" [attr.data-question-id]="question.Id" [attr.data-choice-id]="choice.Id" title="{{choice.Text}}" class="{{choice.Text | replaceSpaces}} material-icons">mood_bad</i>
                                                </div>
                                                <div *ngFor="let choice of sectionChoices | slice:3:6">
                                                    <i (click)="selectFace($event, globalCurrentQuestion+(i))" [attr.data-question-id]="question.Id" [attr.data-choice-id]="choice.Id" title="{{choice.Text}}" class="{{choice.Text | replaceSpaces}} material-icons">mood</i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <!--Satisfaction questions-->


                                <!--Survey questions-->
                                <ng-container *ngIf="!singleChoice && !showIcons">
                                    <div #selects>
                                        <div *ngFor="let questionChoice of questionChoices; let i = index;" class="demographics">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>{{globalCurrentQuestion+(i)}}. {{_ams.sections[currentSection].questions[i].Text}}</label>
                                                    <select #_survey (change)="selectSurvey(_survey.value, $event)">
                                                        <option selected value=""></option>
                                                        <option *ngFor="let property of questionChoice; let j = index;" [attr.data-question-id]="_ams.sections[currentSection].questions[i].Id" value="{{property.Id}}">{{property.Text}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <!--Survey questions-->


                            </ng-container>

                            <ng-container *ngIf="finish">
                                <div class="text-center">
                                    <h2><b>Thank you!</b></h2>
                                    <p>
                                        You have completed the assessment. You will be contacted soon to schedule your debrief.
                                        Your report will be available at the "Reports" section once it is approved by your coach.
                                    </p>
                                </div>
                                <div class="text-right">
                                    <input type="button" class="btn btn-info" value="Finish" (click)="finishAssessment()" />
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
</div>
